import React, { useEffect, useState } from 'react';

import APointIco from '../../../../images/APointIco.svg'
import BPointIco from '../../../../images/BPointIco.svg'
import orderIco from '../../../../images/orderIco.svg'
import dateIco from '../../../../images/dateIco.svg'
import PriceIco from '../../../../images/PriceIco.svg'
import RubleIco from '../../../../images/RubleIco.svg'
import commentIco from '../../../../images/commentIco.svg'

function OrderCreationFirstStep({ page, setPage, inputs, setInputs }) {
    const handleNextPage = (e) => {
        e.preventDefault()
        setPage(page + 1)
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Обновляем состояние для измененного поля
        if (!isNaN(Number(value))) {
            setInputs({
                ...inputs,
                [name]: Number(value)
            });
        } else {
            if (name === 'date') {
                setIsDateSelectActive(false)
                setInputs({
                    ...inputs,
                    [name]: value
                });
            } else {
                setInputs({
                    ...inputs,
                    [name]: value
                });
            }

        }

        checkIsFormValid(name, value);
    }

    const [isDateSelectActive, setIsDateSelectActive] = useState(false)

    const handleDateSelectCheck = (e) => {
        const { name } = e.target;
        setIsDateSelectActive(true)
        setInputs({
            ...inputs,
            date: ''
        });
        checkIsFormValid(name, '');
    }

    const handleDateSelectChange = (e) => {
        const { name, value } = e.target;
        setInputs({
            ...inputs,
            date: new Date(value)
        });

        checkIsFormValid(name, value);
    }

    useEffect(() => {
        if ((new Date(inputs.date).toLocaleString('ru', { month: 'long', day: 'numeric' }) ===
            todayDate.toLocaleString('ru', { month: 'long', day: 'numeric' }) ||
            tomorrowDate.toLocaleString('ru', { month: 'long', day: 'numeric' }) ||
            afterTomorrowDate.toLocaleString('ru', { month: 'long', day: 'numeric' }))
            && inputs.date !== '') {
            setIsDateSelectActive(true)
        } else {
            setIsDateSelectActive(false)
        }
    }, [])

    const handleCityChange = (e) => {
        const { name, value } = e.target;
        let result = {}
        if (isIntercity) {
            result = {
                ...inputs,
                [name]: value
            }
            checkIsFormValid(name, value);
        } else {
            result = {
                ...inputs,
                startCity: value,
                endCity: value,
            }
            checkIsFormValid('startCity', value);
            checkIsFormValid('endCity', value);
        }
        setInputs(result)
    }

    let todayDate = new Date()
    let tomorrowDate = new Date()
    tomorrowDate.setDate(todayDate.getDate() + 1)
    let afterTomorrowDate = new Date()
    afterTomorrowDate.setDate(todayDate.getDate() + 2)

    const [isFormValid, setIsFormValid] = useState(false)

    const [isAdressAValid, setIsAdressAValid] = useState(false)
    const [isAdressBValid, setIsAdressBValid] = useState(false)
    const [isDateValid, setIsDateValid] = useState(false)
    const [isVehicleValid, setIsVehicleValid] = useState(false)
    const [isWeightValid, setIsWeightValid] = useState(false)
    const [isPriceValid, setIsPriceValid] = useState(false)
    const [isVolumeValid, setIsVolumeValid] = useState(false)
    const [isTypeValid, setIsTypeValid] = useState(false)

    const checkIsFormValid = (name, value) => {
        switch (name) {
            case 'startCity':
                if (value.length === 0) {
                    setIsFormValid(false)
                    setIsAdressAValid(false)
                } else {
                    setIsAdressAValid(true)
                }
                break;
            case 'endCity':
                if (value.length === 0) {
                    setIsFormValid(false)
                    setIsAdressBValid(false)
                } else {
                    setIsAdressBValid(true)
                }
                break;
            case 'date':
                if (value.checked === false || value === '') {
                    setIsFormValid(false)
                    setIsDateValid(false)
                } else {
                    setIsDateValid(true)
                }
                break;
            case 'vehicleRequirements':
                if (value.checked === false) {
                    setIsFormValid(false)
                    setIsVehicleValid(false)
                } else {
                    setIsVehicleValid(true)
                }
                break;
            case 'weight':
                if (value.length === 0) {
                    setIsFormValid(false)
                    setIsWeightValid(false)
                } else {
                    setIsWeightValid(true)
                }
                break;
            case 'price':
                if (value.length === 0) {
                    setIsFormValid(false)
                    setIsPriceValid(false)
                } else {
                    setIsPriceValid(true)
                }
                break;
            case 'volume':
                if (value.length === 0) {
                    setIsFormValid(false)
                    setIsVolumeValid(false)
                } else {
                    setIsVolumeValid(true)
                }
                break;
            case 'name':
                if (value.length === 0) {
                    setIsFormValid(false)
                    setIsTypeValid(false)
                } else {
                    setIsTypeValid(true)
                }
                break;
            default:
                break;
        }
    }

    const checkCombinedInputValidity = () => {
        const combinedValidity = (isAdressAValid === true) && (isAdressBValid === true) && (isDateValid === true) && (isVehicleValid === true) && (isWeightValid === true) && (isPriceValid === true) && (isVolumeValid === true) && (isTypeValid === true)
        if (combinedValidity) {
            setIsFormValid(true);
        }
    }

    const checkFrstRndrCombinedInputValidity = () => {
        const combinedValidity = (inputs.startCity.length !== 0) &&
            inputs.endCity.length !== 0 &&
            inputs.date.checked !== false &&
            inputs.vehicleRequirements.checked !== false &&
            inputs.weight.length !== 0 &&
            inputs.price.length !== 0 &&
            inputs.volume.length !== 0 &&
            inputs.name.length !== 0
        if (combinedValidity) {
            setIsFormValid(true);
        }
    }


    useEffect(() => {
        checkCombinedInputValidity();
    })

    useEffect(() => {
        checkFrstRndrCombinedInputValidity()
    }, [])

    const [isIntercity, setIsIntercity] = useState(true)

    return (
        <div className='order-creation__step-conatiner'>
            <form name='order-creation-1' className='order-creation__form' onSubmit={handleNextPage}>
                <h2 className='order-creation__adress-container-title order-creation__container-title'>Откуда-куда:</h2>
                <p className='order-creation__adress-container-subtitle order-creation__container-subtitle'>Выберите необходимый тип перевозки</p>
                <div className='order-creation__type-buttons-container'>
                    <div className='order-creation__check-button-container view-profile-driver_check-reviews'>
                        <input type='radio' name='page' id='insideCity' className='order-creation__check-button' onClick={() => {
                            setIsIntercity(false);
                            setInputs({
                                ...inputs,
                                endCity: inputs.startCity,
                            });
                        }} />
                        <label htmlFor='insideCity' className='view-profile-driver__check-button-label'>По городу</label>
                    </div>
                    <div className='order-creation__check-button-container view-profile-driver_check-main'>
                        <input type='radio' name='page' id='intercity' className='order-creation__check-button' onClick={() => setIsIntercity(true)} defaultChecked />
                        <label htmlFor='intercity' className='view-profile-driver__check-button-label'>Межгород</label>
                    </div>
                </div>
                <div className='order-creation__adress-inputs-container'>

                    <div className='order-creation__adress-icons'>
                        <img src={APointIco} alt='A' className='order-creation__a-point-icon' />
                        {
                            isIntercity &&
                            <>
                                <div className='order-creation__adress-line' />
                                <img src={BPointIco} alt='B' className='order-creation__b-point-icon' />
                            </>
                        }
                    </div>
                    <div className='order-creation__adress-input-container order-creation__adress-input-a'>
                        <img src={orderIco} alt='ввод' className='order-creation__adress-input-icon' />
                        <input type='text' name='startCity' id='adress-a' className='order-creation__adress-input' placeholder={inputs.startCity} onChange={handleCityChange} />
                    </div>
                    {
                        isIntercity &&
                        <div className='order-creation__adress-input-container order-creation__adress-input-b'>
                            <img src={orderIco} alt='ввод' className='order-creation__adress-input-icon' />
                            <input type='text' name='endCity' id='adress-b' className='order-creation__adress-input' placeholder={inputs.endCity} onChange={handleCityChange} />
                        </div>
                    }
                </div>
                <div className='order-creation__date-container'>
                    <div className='order-creation__date-container-header'>
                        <h2 className='order-creation__date-container-title order-creation__container-title'>Дата перевозки:</h2>
                    </div>
                    <div className='order-creation-date-inputs-container'>
                        <div className='order-creation__check-button-container order-creation_check-today'>
                            <input type='radio' name='date' id='today' value={todayDate} className='order-creation__check-button' onChange={handleChange} checked={new Date(inputs.date).toLocaleString('ru', { month: 'long', day: 'numeric' }) === todayDate.toLocaleString('ru', { month: 'long', day: 'numeric' }) ? true : false} />
                            <label htmlFor='today' className='order-creation__check-button-label'>СЕГОДНЯ</label>
                        </div>
                        <div className='order-creation__check-button-container order-creation_check-tomorrow'>
                            <input type='radio' name='date' id='tomorrow' value={tomorrowDate} className='order-creation__check-button' onChange={handleChange} checked={new Date(inputs.date).toLocaleString('ru', { month: 'long', day: 'numeric' }) === tomorrowDate.toLocaleString('ru', { month: 'long', day: 'numeric' }) ? true : false} />
                            <label htmlFor='tomorrow' className='order-creation__check-button-label'>ЗАВТРА</label>
                        </div>
                        <div className='order-creation__check-button-container order-creation_check-next-day'>
                            <input type='radio' name='date' id='next' value={afterTomorrowDate} className='order-creation__check-button' onChange={handleChange} checked={new Date(inputs.date).toLocaleString('ru', { month: 'long', day: 'numeric' }) === afterTomorrowDate.toLocaleString('ru', { month: 'long', day: 'numeric' }) ? true : false} />
                            <label htmlFor='next' className='order-creation__check-button-label'>ПОСЛЕЗАВТРА</label>
                        </div>

                    </div>
                    <div className='order-creation__date-select-container'>
                        <div className='order-creation__check-button-container order-creation_check-select-date'>
                            <input type='radio' name='date' id='select' className='order-creation__check-button' onChange={handleDateSelectCheck} />
                            <label htmlFor='select' className='order-creation__check-button-label'>ВЫБРАТЬ ДАТУ</label>
                        </div>
                        {
                            isDateSelectActive &&
                            <input type='date' className='filter-popup__date-input filter-popup__num-input' value={inputs?.date !== '' ? new Date(inputs.date).toISOString().split('T')[0] : null} onChange={handleDateSelectChange} name='date' />
                        }

                    </div>
                </div>
                <div className='order-creation__body-type-container'>
                    <h2 className='order-creation__body-type-container-title order-creation__container-title'>Нужный тип  кузова:</h2>
                    <div className='order-creation__types-container'>
                        <div className='order-creation__check-button-container order-creation_check-re'>
                            <input type='radio' name='vehicleRequirements' value={'REFRIGE'} id='re' className='order-creation__check-button' onChange={handleChange} checked={inputs.vehicleRequirements === 'REFRIGE' ? true : false} />
                            <label htmlFor='re' className='order-creation__check-button-label'>РЕФРИЖЕРАТОР</label>
                        </div>
                        <div className='order-creation__check-button-container order-creation_check-te'>
                            <input type='radio' name='vehicleRequirements' value={'TENT'} id='te' className='order-creation__check-button' onChange={handleChange} checked={inputs.vehicleRequirements === 'TENT' ? true : false} />
                            <label htmlFor='te' className='order-creation__check-button-label'>ТЕНТИРОВАНЫЙ</label>
                        </div>
                        <div className='order-creation__check-button-container order-creation_check-ce'>
                            <input type='radio' name='vehicleRequirements' value={'FULLMETAL'} id='ce' className='order-creation__check-button' onChange={handleChange} checked={inputs.vehicleRequirements === 'FULLMETAL' ? true : false} />
                            <label htmlFor='ce' className='order-creation__check-button-label'>ЦЕЛЬНОМЕТАЛЛИЧЕСКИЙ</label>
                        </div>
                        <div className='order-creation__check-button-container order-creation_check-iz'>
                            <input type='radio' name='vehicleRequirements' value={'ISOTERMIC'} id='iz' className='order-creation__check-button' onChange={handleChange} checked={inputs.vehicleRequirements === 'ISOTERMIC' ? true : false} />
                            <label htmlFor='iz' className='order-creation__check-button-label'>ИЗОТЕРМИЧЕСКИЙ</label>
                        </div>
                        <div className='order-creation__check-button-container order-creation_check-bo'>
                            <input type='radio' name='vehicleRequirements' value={'BOARD'} id='bo' className='order-creation__check-button' onChange={handleChange} checked={inputs.vehicleRequirements === 'BOARD' ? true : false} />
                            <label htmlFor='bo' className='order-creation__check-button-label'>БОРТОВОЙ</label>
                        </div>
                    </div>
                </div>
                <div className='order-creation__weight-container'>
                    <h2 className='order-creation__weight-container-title order-creation__container-title'>Масса груза:</h2>
                    <div className='order-creation__weight-input-container'>
                        <input type='number' name='weight' id='weight' className='order-creation__weight-input' placeholder={inputs.weight} onChange={handleChange}
                            min={0}
                            onKeyDown={(event) => {
                                if (event.code === 'Minus') {
                                    event.preventDefault();
                                }
                            }}
                        />
                        кг
                    </div>
                </div>
                <div className='order-creation__price-container'>
                    <div className='order-creation__price-container-header'>
                        <h2 className='order-creation__price-container-title order-creation__container-title'>Цена:</h2>
                        <img src={PriceIco} alt='Цена' className='order-creation__price-icon' />
                    </div>
                    <div className='order-creation__price-input-container'>
                        <input type='number' name='price' id='price' className='order-creation__price-input' placeholder={inputs.price} onChange={handleChange}
                            min={0}
                            onKeyDown={(event) => {
                                if (event.code === 'Minus') {
                                    event.preventDefault();
                                }
                            }}
                        />
                        <img src={RubleIco} alt='Р' className='order-creation__price-input-icon' />
                    </div>
                </div>
                <div className='order-creation__volume-container'>
                    <h2 className='order-creation__volume-container-title order-creation__container-title'>Объём груза:</h2>
                    <div className='order-creation__volume-input-container'>
                        <input type='number' name='volume' id='volume' className='order-creation__volume-input' placeholder={inputs.volume} onChange={handleChange}
                            min={0}
                            onKeyDown={(event) => {
                                if (event.code === 'Minus') {
                                    event.preventDefault();
                                }
                            }}
                        />
                        м3
                    </div>
                </div>
                <div className='order-creation__comment-container'>
                    <div className='order-creation__comment-container-header'>
                        <h2 className='order-creation__comment-container-title order-creation__container-title'>Тип груза:</h2>
                    </div>
                    <div className='order-creation__comment-input-container' contentEditable='true' suppressContentEditableWarning={true}>
                        <textarea type='text' className='order-creation__comment-input' cols='40' rows='5' name='name' placeholder={inputs.name} onChange={handleChange} />
                    </div>
                </div>
                <div className='order-creation__comment-container'>
                    <div className='order-creation__comment-container-header'>
                        <h2 className='order-creation__comment-container-title order-creation__container-title'>Примечание к грузу: ⚠ </h2>
                    </div>
                    <div className='order-creation__comment-input-container' contentEditable='true' suppressContentEditableWarning={true}>
                        <textarea type='text' className='order-creation__comment-input' cols='40' rows='5' name='note' placeholder={inputs.note} onChange={handleChange} />
                    </div>
                </div>
                <button type='submit' className='order-creation__submit-button' disabled={!isFormValid} >Далее</button>
            </form>
        </div>
    )
}

export default OrderCreationFirstStep